import * as React from 'react'
import { FC } from 'react'
import { EditableCellCtx } from '../../../../../../../components/editable-cell/editable-cell'
import { Form, InputNumber } from 'antd'
import formatIntegerBySpace from '../../../../../../../helpers/formatters/format-integer-by-space'

const EditAmount: FC = () => {
    const ctx = React.useContext(EditableCellCtx)
    return (
        <Form.Item name={'amount'} noStyle>
            <InputNumber
                autoFocus
                min={0}
                onBlur={ctx.onBlur}
                formatter={formatIntegerBySpace}
                style={{ width: '100%', height: '100%' }}
            />
        </Form.Item>
    )
}

export default EditAmount
